export const DEFAULT_PAYMENT_STATUS_TIMER_DELAY_MS = 2_000;
export const DEFAULT_PAYMENT_STATUS_TIMER_THROTTLE_TIME_MS = 60_000;
export const DEFAULT_PAYMENT_STATUS_TIMER_THROTTLE_INTERVAL_MS = 10_000;
export const DEFAULT_PAYMENT_STATUS_TIMER_COUNTDOWN_TIME_MIN = 15;
